import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsDataManagerObjectClassesEntryPoint } from '@jira/spa-apps__assets-data-manager-object-classes-page/src/assetsDataManagerObjectClassesEntryPoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsDataManagerObjectClassesRoute } from '@jira/router-routes__assets-app-data-manager-routes/src/assetsDataManagerObjectClassesRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const assetsDataManagerObjectClassesPageEntryPoint = createChromelessEntryPoint({
	main: assetsDataManagerObjectClassesEntryPoint,
});

export const assetsDataManagerObjectClassesRouteEntry: Route = createEntry(
	assetsDataManagerObjectClassesRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		perfMetricKey: 'assets-data-manager-object-classes',
		pageId: () => 'spa-apps/assets-data-manager-object-classes',
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],
		entryPoint() {
			return fg('assets_data_manager_jira_spa')
				? assetsDataManagerObjectClassesPageEntryPoint
				: undefined;
		},
		// eslint-disable-next-line no-restricted-syntax
		component: fg('assets_data_manager_jira_spa') ? undefined : ErrorPagesNotFound,
		meta: {
			reporting: {
				id: APP_NAMES.ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE,
				packageName: toPackageName(APP_NAMES.ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE),
				teamName: 'Aurum',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
